module.exports = __webpack_public_path__ + "static/media/komikax_-webfont.cf3a23c7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/themes/fonts/komikax_-webfont.woff
// module id = 328
// module chunks = 1